(function () {

  'use strict';

  function initPreorder() {
    var wrapper = document.querySelector('.enamor-preorder-wrapper');
    if (!wrapper) return;

    var preorderType = (wrapper.dataset.preorderType || '').toLowerCase().trim();
    var leadDays = parseInt(wrapper.dataset.leadDays, 10) || 0;
    var displayDate = wrapper.dataset.displayDate || '';
    var stockData = window.enamorVariantStock || {};

    function getArrivalText() {
      if (preorderType === 'a1' || preorderType === 'a2') {
        var now = new Date();
        now.setDate(now.getDate() + leadDays);
        return '下單後 ' + leadDays + ' 天內出貨（預計 ' + (now.getMonth()+1) + ' 月 ' + now.getDate() + ' 日）';
      }
      return displayDate;
    }

    function getSelectedVariantId() {
      var el = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return el ? el.value : null;
    }

    function getQtyElement() {
      return (
        document.querySelector('safe-sticky select.quantity-selector__input') ||
        document.querySelector('product-info select.quantity-selector__input') ||
        document.querySelector('.product-info select.quantity-selector__input') ||
        document.querySelector('select.quantity-selector__input')
      );
    }

    function getQtyValue() {
      var el = getQtyElement();
      return el ? parseInt(el.value, 10) || 1 : 1;
    }

    function getAddBtn() {
      var sels = ['[data-testid="add-to-cart"]', '.product-form__submit', 'button[name="add"]', 'buy-buttons button:not(.shopify-payment-button__button)', 'buy-buttons .button--outline', 'buy-buttons .button'];
      for (var i = 0; i < sels.length; i++) { var b = document.querySelector(sels[i]); if (b) return b; }
      return null;
    }

    function isVariantPreorder(id) {
      if (!id) return false;
      if (preorderType === 'a1' || preorderType === 'a2') {
        var v = stockData[String(id)];
        return v && v.continue === 'continue' && v.qty <= 0;
      }
      if (preorderType === 'b') return wrapper.dataset.showPreorder === 'true';
      return false;
    }

    // Insert notice before <buy-buttons> in the parent v-stack
    function getOrCreateNotice() {
      var notice = document.querySelector('.enamor-preorder-notice');
      if (!notice) {
        notice = document.createElement('div');
        notice.className = 'enamor-preorder-notice';
        var buyButtons = document.querySelector('buy-buttons');
        if (buyButtons && buyButtons.parentElement) {
          buyButtons.parentElement.insertBefore(notice, buyButtons);
        } else {
          var addBtn = getAddBtn();
          if (addBtn && addBtn.parentElement) {
            addBtn.parentElement.insertBefore(notice, addBtn);
          }
        }
      }
      return notice;
    }

    function updateStockNotice(variantId) {
      var notice = document.querySelector('.enamor-preorder-notice');
      var vdata = variantId ? stockData[String(variantId)] : null;
      if (!vdata || vdata.continue !== 'continue' || vdata.qty <= 0) {
        if (notice) notice.remove();
        return;
      }
      var qty = getQtyValue();
      var stock = vdata.qty;
      if (qty > stock) {
        notice = getOrCreateNotice();
        notice.textContent = '注意：您購買的數量（' + qty + '）超出現有庫存（' + stock + '），});超出部分將已預購方式等待商品到貨一併寄出';
      } else {
        if (notice) notice.remove();
      }
    }

    function isDenyOutOfStock(variantId) {
      var id = variantId || getSelectedVariantId();
      if (!id) {
        var keys = Object.keys(stockData);
        if (!keys.length) return false;
        id = keys[0];
      }
      var v = stockData[String(id)];
      return v && v.continue === 'deny' && (v.qty <= 0 || v.available === false);
    }

    function getAllAddBtns() {
      var sels = ['[data-testid="add-to-cart"]', '.product-form__submit', 'button[name="add"]', 'buy-buttons button:not(.shopify-payment-button__button)', 'buy-buttons .button--outline', 'buy-buttons .button'];
      var found = [];
      sels.forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          if (found.indexOf(el) === -1) found.push(el);
        });
      });
      return found;
    }

    function setDenyMode(isDeny) {
      var btns = getAllAddBtns();
      var qtyEl = getQtyElement();
      if (isDeny) {
        btns.forEach(function(btn) {
          btn.disabled = true;
          btn.dataset.originalText = btn.dataset.originalText || btn.textContent.trim();
          btn.textContent = '已售完';
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
          btn.style.pointerEvents = 'none';
        });
        if (qtyEl) {
          qtyEl.disabled = true;
          qtyEl.style.opacity = '0.5';
          qtyEl.style.pointerEvents = 'none';
        }
      } else {
        btns.forEach(function(btn) {
          btn.disabled = false;
          if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.style.pointerEvents = '';
        });
        if (qtyEl) {
          qtyEl.disabled = false;
          qtyEl.style.opacity = '';
          qtyEl.style.pointerEvents = '';
        }
      }
    }

    function setPreorderMode(isPreorder, variantId) {
      var addBtn = getAddBtn();
      var productForm = document.querySelector('product-form form[action*="/cart/add"]') ||
                         document.querySelector('safe-sticky form[action*="/cart/add"]');
      var oldBadge = wrapper.querySelector('.enamor-preorder-badge');
      var oldText = wrapper.querySelector('.enamor-preorder-text');

      // 先處理 deny 模式
      setDenyMode(isDenyOutOfStock(variantId));

      if (isPreorder) {
        if (!oldBadge) {
          var badge = document.createElement('span');
          badge.className = 'enamor-preorder-badge';
          badge.textContent = '預購中';
          wrapper.insertBefore(badge, wrapper.firstChild);
        }
        var dt = oldText || document.createElement('p');
        dt.className = 'enamor-preorder-text';
        dt.textContent = '預購到貨日：' + getArrivalText();
        if (!oldText) wrapper.appendChild(dt);
        if (addBtn) {
          addBtn.dataset.originalText = addBtn.dataset.originalText || addBtn.textContent.trim();
          addBtn.textContent = '預購下單';
        }
        if (productForm) {
          productForm.classList.add('enamor-preorder-active');
          if (!productForm.querySelector('input[name="properties[預購]"]')) {
            var propInput = document.createElement('input');
            propInput.type = 'hidden';
            propInput.name = 'properties[預購]';
            propInput.value = '依訂單順序到貨後發貨';
            productForm.appendChild(propInput);
          }
        }
      } else {
        if (oldBadge) oldBadge.remove();
        if (oldText) oldText.remove();
        if (addBtn && addBtn.dataset.originalText) addBtn.textContent = addBtn.dataset.originalText;
        if (productForm) {
          productForm.classList.remove('enamor-preorder-active');
          var existingProp = productForm.querySelector('input[name="properties[預購]"]');
          if (existingProp) existingProp.remove();
        }
      }
    }

    function run(variantId) {
      var id = variantId || getSelectedVariantId();
      setPreorderMode(isVariantPreorder(id), id);
      updateStockNotice(id);
    }

    function watchQty() {
      var el = getQtyElement();
      if (!el) return;
      var handler = function () { updateStockNotice(getSelectedVariantId()); };
      el.addEventListener('change', handler);
      el.addEventListener('input', handler);
    }

    document.addEventListener('variant:change', function (e) {
      var id = e.detail && e.detail.variant && e.detail.variant.id ? String(e.detail.variant.id) : null;
      var qtyEl = getQtyElement();
      if (qtyEl) qtyEl.value = '1';
      run(id);
    });

    var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (formInput) new MutationObserver(function () { run(null); }).observe(formInput, { attributes: true, attributeFilter: ['value'] });

    watchQty();
    run(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorder);
  } else {
    initPreorder();
  }
  // ── Storefront 庫存輪詢 ────────────────────────────────────────────
  var STOREFRONT_ENDPOINT = 'https://er1zrf-eq.myshopify.com/api/2026-01/graphql.json';
  var STOREFRONT_TOKEN    = 'f241b67ff70d714e1cc030a83ce5e675';

  function fetchAllVariantStock() {
    var variantEls = document.querySelectorAll('[data-variant-id]');
    if (!variantEls.length) return;
    var ids = Array.from(variantEls).map(function (el) {
      return 'gid://shopify/ProductVariant/' + el.dataset.variantId;
    });
    ids = ids.filter(function (v, i, a) { return a.indexOf(v) === i; });
    var chunks = [];
    for (var i = 0; i < ids.length; i += 250) { chunks.push(ids.slice(i, i + 250)); }
    chunks.forEach(function (chunk) {
      var query = '{ nodes(ids: ' + JSON.stringify(chunk) + ') { ... on ProductVariant { id quantityAvailable } } }';
      fetch(STOREFRONT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var nodes = (data.data && data.data.nodes) ? data.data.nodes : [];
        var updated = false;
        nodes.forEach(function (node) {
          if (!node || !node.id) return;
          var numericId = node.id.replace('gid://shopify/ProductVariant/', '');
          var qty = node.quantityAvailable;
          if (window.enamorVariantStock[numericId] !== qty) {
            window.enamorVariantStock[numericId] = qty;
            updated = true;
          }
        });
        if (updated) {
          document.dispatchEvent(new CustomEvent('variant:change'));
        }
      })
      .catch(function (err) { console.warn('[enamor-preorder] 輪詢失敗', err); });
    });
  }

  function scheduleStockPolling() {
    var now     = new Date();
    var minutes = now.getMinutes();
    var seconds = now.getSeconds();
    var targets = [27, 42];
    var next    = null;
    for (var i = 0; i < targets.length; i++) {
      var diff = (targets[i] - minutes) * 60 - seconds;
      if (diff > 0) { next = diff; break; }
    }
    if (next === null) { next = (60 - minutes + 27) * 60 - seconds; }
    setTimeout(function () {
      fetchAllVariantStock();
      scheduleStockPolling();
    }, next * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fetchAllVariantStock();
      scheduleStockPolling();
    });
  } else {
    fetchAllVariantStock();
    scheduleStockPolling();
  }

  // ── QuickBuy Modal 支援 ────────────────────────────────────────────────
  // QuickBuy 用 replaceChildren 注入 DOM，<script> 不會自動執行
  // 用 MutationObserver 偵測 quick-buy-modal 內容變化，手動執行 enamorVariantStock 初始化並重跑 initPreorder
  function initForContext(root) {
    // 執行 root 內的 enamor-preorder-banner script
    var scripts = root.querySelectorAll('script');
    scripts.forEach(function(s) {
      if (s.textContent.indexOf('enamorVariantStock') !== -1) {
        try { (new Function(s.textContent))(); } catch(e) {}
      }
    });
    // 重跑 initPreorder（使用 root 內的 wrapper）
    var wrapper = root.querySelector('.enamor-preorder-wrapper');
    if (!wrapper) return;
    var preorderType = (wrapper.dataset.preorderType || '').toLowerCase().trim();
    var leadDays = parseInt(wrapper.dataset.leadDays, 10) || 0;
    var displayDate = wrapper.dataset.displayDate || '';
    var stockData = window.enamorVariantStock || {};

    function getAddBtnsIn(container) {
      var sels = ['[data-testid="add-to-cart"]', '.product-form__submit', 'button[name="add"]',
                  'buy-buttons button:not(.shopify-payment-button__button)', 'buy-buttons .button--outline', 'buy-buttons .button'];
      var found = [];
      sels.forEach(function(sel) {
        container.querySelectorAll(sel).forEach(function(el) {
          if (found.indexOf(el) === -1) found.push(el);
        });
      });
      return found;
    }

    function getQtyIn(container) {
      return container.querySelector('safe-sticky select.quantity-selector__input') ||
             container.querySelector('product-info select.quantity-selector__input') ||
             container.querySelector('select.quantity-selector__input');
    }

    function getSelectedId(container) {
      var el = container.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return el ? el.value : null;
    }

    function isPreorder(id) {
      if (!id) return false;
      if (preorderType === 'a1' || preorderType === 'a2') {
        var v = stockData[String(id)];
        return v && v.continue === 'continue' && v.qty <= 0;
      }
      if (preorderType === 'b') return wrapper.dataset.showPreorder === 'true';
      return false;
    }

    function isDenyOOS(id) {
      var v = stockData[String(id)];
      return v && v.continue === 'deny' && (v.qty <= 0 || v.available === false);
    }

    function getArrivalText() {
      if (preorderType === 'a1' || preorderType === 'a2') {
        var now = new Date();
        now.setDate(now.getDate() + leadDays);
        return '下單後 ' + leadDays + ' 天內出貨（預計 ' + (now.getMonth()+1) + ' 月 ' + now.getDate() + ' 日）';
      }
      return displayDate;
    }

    function applyMode(variantId) {
      var id = variantId || getSelectedId(root);
      var btns = getAddBtnsIn(root);
      var qtyEl = getQtyIn(root);
      var oldBadge = wrapper.querySelector('.enamor-preorder-badge');
      var oldText = wrapper.querySelector('.enamor-preorder-text');
      var productForm = root.querySelector('product-form form[action*="/cart/add"]') ||
                        root.querySelector('safe-sticky form[action*="/cart/add"]') ||
                        root.querySelector('form[action*="/cart/add"]');

      if (isDenyOOS(id)) {
        btns.forEach(function(btn) {
          btn.disabled = true;
          btn.dataset.originalText = btn.dataset.originalText || btn.textContent.trim();
          btn.textContent = '已售完';
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
          btn.style.pointerEvents = 'none';
        });
        if (qtyEl) { qtyEl.disabled = true; qtyEl.style.opacity = '0.5'; }
        if (oldBadge) oldBadge.remove();
        if (oldText) oldText.remove();
      } else if (isPreorder(id)) {
        btns.forEach(function(btn) {
          btn.disabled = false;
          btn.style.opacity = ''; btn.style.cursor = ''; btn.style.pointerEvents = '';
          btn.dataset.originalText = btn.dataset.originalText || btn.textContent.trim();
          btn.textContent = '預購下單';
        });
        if (qtyEl) { qtyEl.disabled = false; qtyEl.style.opacity = ''; }
        if (!oldBadge) {
          var badge = document.createElement('span');
          badge.className = 'enamor-preorder-badge';
          badge.textContent = '預購中';
          wrapper.insertBefore(badge, wrapper.firstChild);
        }
        var dt = oldText || document.createElement('p');
        dt.className = 'enamor-preorder-text';
        dt.textContent = '預購到貨日：' + getArrivalText();
        if (!oldText) wrapper.appendChild(dt);
        if (productForm && !productForm.querySelector('input[name="properties[預購]"]')) {
          var inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'properties[預購]'; inp.value = '依訂單順序到貨後發貨';
          productForm.appendChild(inp);
        }
      } else {
        btns.forEach(function(btn) {
          if (btn.dataset.originalText) {
            btn.disabled = false; btn.textContent = btn.dataset.originalText;
            btn.style.opacity = ''; btn.style.cursor = ''; btn.style.pointerEvents = '';
          }
        });
        if (qtyEl) { qtyEl.disabled = false; qtyEl.style.opacity = ''; }
        if (oldBadge) oldBadge.remove();
        if (oldText) oldText.remove();
        if (productForm) {
          var ep = productForm.querySelector('input[name="properties[預購]"]');
          if (ep) ep.remove();
        }
      }
    }

    applyMode(null);

    root.addEventListener('variant:change', function(e) {
      var id = e.detail && e.detail.variant && e.detail.variant.id ? String(e.detail.variant.id) : null;
      applyMode(id);
    });
  }

  // 監聽 QuickBuy modal 內容注入
  var quickBuyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'childList' && m.addedNodes.length) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var wrapper = node.querySelector ? node.querySelector('.enamor-preorder-wrapper') : null;
            if (wrapper) {
              setTimeout(function() { initForContext(node); }, 50);
            }
          }
        });
      }
    });
  });

  document.querySelectorAll('quick-buy-modal').forEach(function(modal) {
    quickBuyObserver.observe(modal, { childList: true, subtree: true });
  });

  // 動態新增的 quick-buy-modal 也要監聽
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.tagName && node.tagName.toLowerCase() === 'quick-buy-modal') {
          quickBuyObserver.observe(node, { childList: true, subtree: true });
        }
      });
    });
  }).observe(document.body, { childList: true });
  // ── QuickBuy 支援結束 ───────────────────────────────────────────────────

  // ── 輪詢結束 ────────────────────────────────────────────────────  
})(); 